export default "__VITE_ASSET__4cUbS7eI__ 740w";